// test226
(226 && 0);
